export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  author: string;
  publishDate: string;
  readTime: string;
  imageUrl: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    slug: 'what-is-91cn',
    title: '什么是91.cn com？平台全面介绍',
    excerpt: '91.cn com是一个综合性网络内容平台，致力于为用户提供丰富多样的数字内容服务。本文将全面介绍平台的背景、定位与核心价值。',
    content: `<p>91.cn com是一个备受用户关注的综合性网络内容平台，自上线以来，凭借其丰富的内容资源和便捷的使用体验，吸引了大量用户的关注与使用。</p>
<h2>平台背景</h2>
<p>91.cn com作为数字内容领域的重要参与者，始终坚持以用户需求为导向，不断优化平台功能与内容生态。平台汇聚了海量的优质内容资源，涵盖多个领域和类别，满足不同用户群体的多样化需求。</p>
<h2>核心定位</h2>
<p>91.cn com定位于为用户提供<strong>高质量、多元化、便捷访问</strong>的数字内容服务。平台通过先进的技术架构和智能推荐算法，帮助用户快速发现感兴趣的内容，提升内容消费效率。</p>
<h2>平台特色</h2>
<ul>
<li><strong>内容丰富：</strong>涵盖多个内容类别，总资源量超过百万级别</li>
<li><strong>访问便捷：</strong>支持多终端访问，随时随地畅享内容</li>
<li><strong>安全合规：</strong>严格遵循相关法律法规，保障用户权益</li>
<li><strong>体验优化：</strong>持续迭代产品功能，提升用户使用体验</li>
</ul>
<h2>用户群体</h2>
<p>91.cn com的用户群体广泛，包括普通内容消费者、专业内容创作者以及内容分发商等。平台为不同类型的用户提供了差异化的服务和功能，满足各方需求。</p>`,
    category: 'platform-intro',
    categoryName: '平台介绍',
    author: '91.cn com编辑团队',
    publishDate: '2026-07-15',
    readTime: '5分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20digital%20content%20platform%20interface%20with%20warm%20ambient%20lighting%2C%20abstract%20technology%20visualization%2C%20clean%20minimalist%20design%20elements%20floating%20in%20a%20soft%20gradient%20background%2C%20editorial%20photography%20style%20with%20warm%20orange%20and%20cream%20tones%2C%20professional%20composition&width=1200&height=600&seq=article-what-is-91cn&orientation=landscape',
    tags: ['平台介绍', '入门指南', '核心价值'],
  },
  {
    slug: '91cn-platform-history',
    title: '91.cn com平台发展历程与里程碑',
    excerpt: '回顾91.cn com从创立至今的重要发展节点，了解平台如何逐步成长为广受用户信赖的内容平台。',
    content: `<p>91.cn com的发展历程是一段持续创新与进步的旅程。本文将带您回顾平台的重要发展节点和里程碑事件。</p>
<h2>创立初期</h2>
<p>91.cn com在创立之初就明确了以用户需求为核心的发展理念，通过精准的市场定位和优质的内容服务，迅速获得了第一批忠实用户的认可。</p>
<h2>快速成长期</h2>
<p>随着用户规模的不断扩大，91.cn com在技术架构和内容生态方面进行了大量投入，推出了多项创新功能，显著提升了平台的综合竞争力。</p>
<h2>成熟运营期</h2>
<p>经过多年的持续运营和优化，91.cn com已经建立了完善的内容管理体系和用户服务体系，成为行业内有影响力的内容平台之一。</p>
<h2>未来展望</h2>
<p>91.cn com将继续秉持创新驱动的发展理念，在人工智能、大数据等领域深入探索，为用户提供更加智能化、个性化的内容服务体验。</p>`,
    category: 'platform-intro',
    categoryName: '平台介绍',
    author: '91.cn com编辑团队',
    publishDate: '2026-07-10',
    readTime: '6分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Timeline%20visualization%20with%20warm%20orange%20and%20cream%20background%2C%20abstract%20growth%20chart%20illustration%20with%20organic%20flowing%20shapes%2C%20modern%20professional%20aesthetic%2C%20clean%20minimal%20design%20elements%2C%20soft%20gradient%20lighting%2C%20editorial%20quality&width=1200&height=600&seq=article-platform-history&orientation=landscape',
    tags: ['平台发展', '历史回顾', '里程碑'],
  },
  {
    slug: 'content-recommendation',
    title: '91.cn com智能推荐功能详解',
    excerpt: '深入了解91.cn com的智能推荐系统如何通过先进的算法技术，为用户精准匹配感兴趣的内容。',
    content: `<p>91.cn com的智能推荐系统是平台的核心功能之一，通过先进的算法技术，为用户提供个性化的内容推荐服务。</p>
<h2>推荐算法原理</h2>
<p>91.cn com的推荐系统融合了协同过滤、内容分析和深度学习等多种算法，综合分析用户的浏览行为、兴趣偏好和互动数据，实现精准的内容匹配。</p>
<h2>个性化体验</h2>
<p>每位用户在91.cn com平台上都能获得独特的推荐体验。系统会根据用户的实时行为动态调整推荐策略，确保推荐内容始终符合用户的当前兴趣。</p>
<h2>推荐效果</h2>
<p>通过持续的算法优化和数据积累，91.cn com的推荐准确率持续提升，用户平均内容消费时长显著增长，用户满意度也保持在较高水平。</p>`,
    category: 'features',
    categoryName: '功能解析',
    author: '91.cn com技术团队',
    publishDate: '2026-07-12',
    readTime: '7分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20AI%20recommendation%20system%20visualization%2C%20floating%20data%20nodes%20connected%20by%20warm%20orange%20lines%2C%20minimalist%20technology%20aesthetic%2C%20soft%20cream%20background%20with%20subtle%20gradient%2C%20modern%20clean%20design%2C%20editorial%20photography%20quality&width=1200&height=600&seq=article-recommendation&orientation=landscape',
    tags: ['智能推荐', '个性化', '算法技术'],
  },
  {
    slug: 'search-function-guide',
    title: '91.cn com搜索功能使用技巧',
    excerpt: '掌握91.cn com的高级搜索技巧，快速精准地找到您需要的内容资源。',
    content: `<p>91.cn com提供了强大的搜索功能，帮助用户在庞大的内容库中快速定位目标内容。本文将详细介绍搜索功能的使用技巧。</p>
<h2>基础搜索</h2>
<p>在搜索框中输入关键词即可进行基础搜索。系统支持模糊匹配和智能纠错，即使输入不完整或存在拼写错误，也能返回相关结果。</p>
<h2>高级搜索</h2>
<p>91.cn com的高级搜索支持多种筛选条件，包括内容类型、发布时间、热度排序等。用户可以通过组合筛选条件，大幅缩小搜索范围，提高查找效率。</p>
<h2>搜索技巧</h2>
<ul>
<li>使用引号进行精确匹配搜索</li>
<li>利用分类筛选缩小搜索范围</li>
<li>通过排序功能快速定位热门内容</li>
<li>善用搜索历史快速重复搜索</li>
</ul>`,
    category: 'features',
    categoryName: '功能解析',
    author: '91.cn com产品团队',
    publishDate: '2026-07-08',
    readTime: '5分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20search%20interface%20design%20concept%2C%20minimalist%20search%20bar%20with%20magnifying%20glass%20icon%2C%20warm%20orange%20accent%20colors%2C%20floating%20abstract%20data%20elements%2C%20cream%20white%20background%2C%20clean%20professional%20aesthetic%2C%20editorial%20quality&width=1200&height=600&seq=article-search&orientation=landscape',
    tags: ['搜索功能', '使用技巧', '高级搜索'],
  },
  {
    slug: 'registration-guide',
    title: '91.cn com注册与登录完整教程',
    excerpt: '详细讲解91.cn com的注册流程、登录方式以及账号管理技巧，帮助新用户快速完成账号设置。',
    content: `<p>本文将详细介绍91.cn com的注册与登录流程，帮助新用户顺利完成账号创建和登录操作。</p>
<h2>注册步骤</h2>
<ol>
<li>访问91.cn com官方网站，点击右上角的"注册"按钮</li>
<li>填写必要的注册信息，包括用户名、密码和邮箱地址</li>
<li>阅读并同意用户协议和隐私政策</li>
<li>完成邮箱验证或手机验证</li>
<li>注册成功后即可登录使用平台</li>
</ol>
<h2>登录方式</h2>
<p>91.cn com支持多种登录方式，包括账号密码登录、手机验证码登录以及第三方社交账号快捷登录，方便用户根据自己的习惯选择合适的方式。</p>
<h2>账号安全</h2>
<p>建议用户设置复杂度较高的密码，并定期更换。开启二次验证功能可以进一步提升账号安全性。</p>`,
    category: 'user-guide',
    categoryName: '使用指南',
    author: '91.cn com客服团队',
    publishDate: '2026-07-05',
    readTime: '4分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20registration%20form%20interface%20on%20a%20laptop%20screen%2C%20warm%20ambient%20lighting%2C%20minimalist%20UI%20design%20with%20orange%20accent%20buttons%2C%20cream%20background%2C%20clean%20professional%20workspace%20setting%2C%20editorial%20photography%20quality&width=1200&height=600&seq=article-registration&orientation=landscape',
    tags: ['注册教程', '登录指南', '账号管理'],
  },
  {
    slug: 'mobile-app-usage',
    title: '91.cn com移动端使用全攻略',
    excerpt: '全面介绍91.cn com在手机和平板等移动设备上的使用方法和注意事项。',
    content: `<p>91.cn com提供了完善的移动端支持，用户可以通过手机浏览器或专用客户端随时随地访问平台内容。</p>
<h2>移动网页版</h2>
<p>通过手机浏览器直接访问91.cn com即可使用移动网页版。移动网页版针对小屏幕设备进行了优化，界面简洁、操作流畅，提供与桌面端一致的核心功能。</p>
<h2>移动客户端</h2>
<p>91.cn com的移动客户端提供了更加优化的使用体验，包括离线缓存、推送通知、手势操作等专属功能。用户可以在官方应用商店下载安装。</p>
<h2>使用技巧</h2>
<ul>
<li>开启WiFi环境下自动缓存功能，节省流量</li>
<li>使用夜间模式保护视力</li>
<li>设置个性化首页，快速访问常用功能</li>
</ul>`,
    category: 'user-guide',
    categoryName: '使用指南',
    author: '91.cn com产品团队',
    publishDate: '2026-07-03',
    readTime: '6分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20a%20modern%20content%20platform%20app%20interface%2C%20warm%20orange%20and%20cream%20color%20scheme%2C%20clean%20minimalist%20UI%2C%20held%20in%20hand%20against%20a%20soft%20blurred%20background%2C%20editorial%20product%20photography%20style&width=1200&height=600&seq=article-mobile&orientation=landscape',
    tags: ['移动端', '手机使用', '客户端'],
  },
  {
    slug: 'account-security-tips',
    title: '91.cn com账号安全防护最佳实践',
    excerpt: '学习如何保护您的91.cn com账号安全，防范各类网络安全威胁和攻击。',
    content: `<p>账号安全是使用91.cn com的基础保障。本文将为您介绍账号安全防护的最佳实践和注意事项。</p>
<h2>密码安全</h2>
<p>设置强密码是保护账号的第一步。建议使用包含大小写字母、数字和特殊字符的组合密码，长度不少于12位。避免使用生日、手机号等容易被猜测的信息作为密码。</p>
<h2>二次验证</h2>
<p>开启二次验证功能可以显著提升账号安全性。即使密码泄露，攻击者也无法在缺少第二重验证的情况下登录您的账号。</p>
<h2>安全习惯</h2>
<ul>
<li>不要在公共设备上保存登录状态</li>
<li>定期检查账号登录记录，发现异常及时处理</li>
<li>警惕钓鱼网站和虚假客服信息</li>
<li>只在官方渠道下载客户端</li>
</ul>`,
    category: 'safety',
    categoryName: '安全建议',
    author: '91.cn com安全团队',
    publishDate: '2026-06-28',
    readTime: '5分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20cybersecurity%20concept%20visualization%2C%20shield%20icon%20with%20warm%20orange%20glow%2C%20floating%20lock%20symbols%2C%20minimalist%20design%20on%20cream%20background%2C%20clean%20professional%20aesthetic%2C%20high%20quality%20editorial%20illustration%20style&width=1200&height=600&seq=article-security&orientation=landscape',
    tags: ['账号安全', '密码保护', '安全防护'],
  },
  {
    slug: 'privacy-protection',
    title: '91.cn com隐私保护政策解读',
    excerpt: '详细解读91.cn com的隐私保护政策，了解平台如何收集、使用和保护您的个人信息。',
    content: `<p>91.cn com高度重视用户隐私保护，制定了严格的隐私保护政策。本文将帮助您了解平台在隐私保护方面的具体措施。</p>
<h2>信息收集</h2>
<p>91.cn com仅收集提供服务所必需的用户信息，并在收集前明确告知用户信息的用途和范围。用户有权选择是否提供非必要信息。</p>
<h2>信息使用</h2>
<p>平台收集的用户信息仅用于提升服务质量和用户体验，不会将用户信息出售或共享给第三方，除非获得用户明确同意或法律法规要求。</p>
<h2>用户权利</h2>
<p>用户享有查阅、更正、删除个人信息的权利。平台提供了便捷的隐私设置入口，用户可以随时调整隐私偏好。</p>`,
    category: 'safety',
    categoryName: '安全建议',
    author: '91.cn com法务团队',
    publishDate: '2026-06-25',
    readTime: '4分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20privacy%20protection%20concept%2C%20stylized%20lock%20and%20shield%20combined%20design%2C%20warm%20orange%20and%20cream%20tones%2C%20minimalist%20modern%20aesthetic%2C%20soft%20gradient%20background%2C%20editorial%20illustration%20quality&width=1200&height=600&seq=article-privacy&orientation=landscape',
    tags: ['隐私保护', '个人信息', '数据安全'],
  },
  {
    slug: 'content-loading-issue',
    title: '91.cn com内容加载失败的解决方法',
    excerpt: '当遇到内容无法加载或加载缓慢的问题时，按照本文提供的方法进行排查和解决。',
    content: `<p>在使用91.cn com时，偶尔可能会遇到内容加载失败或加载速度慢的情况。本文汇总了常见原因和对应的解决方法。</p>
<h2>网络问题排查</h2>
<p>首先检查网络连接是否正常。尝试切换WiFi和移动数据网络，或重启路由器。在某些网络环境下可能需要使用VPN服务才能正常访问。</p>
<h2>浏览器缓存</h2>
<p>清除浏览器缓存和Cookie通常可以解决加载异常问题。在浏览器设置中找到"清除浏览数据"选项，选择清除缓存和Cookie后重新访问。</p>
<h2>DNS设置</h2>
<p>尝试更换DNS服务器可能有助于解决访问问题。推荐使用公共DNS服务，如Google DNS (8.8.8.8) 或 Cloudflare DNS (1.1.1.1)。</p>`,
    category: 'faq',
    categoryName: '常见问题',
    author: '91.cn com技术支持',
    publishDate: '2026-06-20',
    readTime: '3分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20troubleshooting%20concept%20visualization%2C%20minimalist%20design%20with%20warm%20orange%20warning%20icons%2C%20clean%20cream%20background%2C%20modern%20UI%20elements%2C%20professional%20editorial%20illustration%20style%20with%20soft%20lighting&width=1200&height=600&seq=article-loading&orientation=landscape',
    tags: ['加载问题', '故障排除', '网络设置'],
  },
  {
    slug: 'payment-faq',
    title: '91.cn com支付相关常见问题汇总',
    excerpt: '关于91.cn com的支付方式、退款流程和费用说明等常见问题的详细解答。',
    content: `<p>本文汇总了用户在91.cn com平台上最常遇到的与支付相关的问题及详细解答。</p>
<h2>支持的支付方式</h2>
<p>91.cn com支持多种主流支付方式，包括银行卡支付、第三方支付平台（如支付宝、微信支付）等，确保用户可以选择最便捷的支付渠道。</p>
<h2>退款流程</h2>
<p>如遇到需要退款的情况，用户可以在订单页面提交退款申请。平台会在收到申请后的1-3个工作日内进行审核处理，审核通过后将原路退回款项。</p>
<h2>费用说明</h2>
<p>91.cn com的收费标准公开透明，所有费用在用户确认支付前都会明确显示。平台不会在未经用户确认的情况下扣取任何费用。</p>`,
    category: 'faq',
    categoryName: '常见问题',
    author: '91.cn com客服团队',
    publishDate: '2026-06-18',
    readTime: '4分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20online%20payment%20interface%20concept%2C%20minimalist%20design%20with%20warm%20orange%20accent%20elements%2C%20floating%20payment%20icons%2C%20cream%20white%20background%2C%20clean%20professional%20aesthetic%2C%20editorial%20quality%20illustration&width=1200&height=600&seq=article-payment&orientation=landscape',
    tags: ['支付问题', '退款流程', '费用说明'],
  },
];

export function getArticlesByCategory(categorySlug: string): Article[] {
  return articles.filter((a) => a.category === categorySlug);
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}